import * as types from "../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.ORDERS_SUMMARY_EMAIL_FETCHING:
            return { loading: true };

        case types.ORDERS_SUMMARY_EMAIL_FETCHING_COMPLETED:
            return { loading: false };

        case types.ORDERS_SUMMARY_EMAIL_FETCHING_FAILED:
            return { loading: false, err: action.type };

        default:
            return state;
    }
};
